import * as queryString from 'query-string'

import { history } from '../configureHistory'
import { QueryStringParams } from '../services/QueryStringParams'

export const appendQueryParams = (query: any) => {
    const location = history.location

    let path = location.pathname
    if (!!query) {
        const queryStr = QueryStringParams.toQueryString(query)
        path = `${path}?${queryStr}`
    }
    if (path !== location.pathname + location.search) {
        history.push(path)
    }
}
export const appendCertainQueryParams = (query: Record<string, any>) => {
    const location = history.location

    const parsed = queryString.parse(location.search)

    const newPath = queryString.stringifyUrl({
        query: { ...parsed, ...query },
        url: location.pathname
    })

    history.push(newPath)
}
export const clearQueryParams = () => {
    const location = history.location

    history.push(location.pathname)
}
export const getQueryParams = <T = Record<string, string>>(): T => {
    return queryString.parse(history.location.search) as any
}
